import { render, staticRenderFns } from "./SchoolClassSearchItems.vue?vue&type=template&id=78aae304"
import script from "./SchoolClassSearchItems.vue?vue&type=script&lang=js"
export * from "./SchoolClassSearchItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports